import type { ContrastScores } from 'polished/lib/types/color';

export const resizeDrawerMinWidth = '21.875rem';
export const resizeDrawerMaxWidth = 'calc(100vw - 20rem)';
export const resizeDrawerDefaultWidth =
  'clamp(21.875rem, (100vw - 31.25rem) / 10 + 21.875rem, 31.25rem)';
export const resizeDrawerKeyboardStep = 0.05;

export const portalAgentMinWidth = '20rem';
export const portalAgentDefaultWidth = '31.25rem';

export const wcagContrast: Record<keyof ContrastScores | 'AANonText', number> = {
  // https://www.w3.org/TR/WCAG21/#contrast-minimum
  AA: 4.5,
  AALarge: 3,
  // https://www.w3.org/TR/WCAG21/#contrast-enhanced
  AAA: 7,
  AAALarge: 4.5,
  // https://www.w3.org/TR/WCAG21/#non-text-contrast
  AANonText: 3
};
